import { useState, useEffect, useRef } from 'react';
import { ChevronRight } from 'lucide-react';

// Mensagens do ticker
const tickerMessages = [
  "• Troca Grátis",
  "• Até 12x no cartão",
  "• Compra 100% segura",
  "• Enviamos pra todo Brasil",
  "• 10% OFF na primeira compra",
  "• Cupom BEMVINDO10",
  "• Crie sua conta e ganhe R$20,00",
  "• Brinde em compras acima de R$1.200",
  "• Rastreie seu pedido em tempo real"
];

// Componente Ticker com transição suave
const Ticker = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [slideFromLeft, setSlideFromLeft] = useState(true);
  const [isPaused, setIsPaused] = useState(false);
  const pauseTimer = useRef(null);

  const advance = (index) => {
    const nextIndex = (index + 1) % tickerMessages.length;
    setIsAnimating(true);
    setTimeout(() => {
      setCurrentIndex(nextIndex);
      if (nextIndex % 3 === 0) setSlideFromLeft(prev => !prev);
      setIsAnimating(false);
    }, 400);
  };

  // Auto-play a cada 8 segundos — para quando o usuário clica manualmente
  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => {
      if (!isAnimating) advance(currentIndex);
    }, 8000);
    return () => clearInterval(interval);
  }, [isPaused, currentIndex, isAnimating]);

  const handleNext = () => {
    if (isAnimating) return;

    // Pausa o auto-play e retoma após 16 segundos
    setIsPaused(true);
    if (pauseTimer.current) clearTimeout(pauseTimer.current);
    pauseTimer.current = setTimeout(() => setIsPaused(false), 20000);

    advance(currentIndex);
  };

  return (
    <div className="bg-[#0d0d0d] text-[#f7f7f7] overflow-hidden shadow-[inset_0_8px_20px_-10px_rgba(247,247,247,0.15),inset_0_-8px_20px_-10px_rgba(247,247,247,0.15)]">
      <div className="max-w-7xl mx-auto px-4 py-0.5 flex items-center justify-center">
        {/* Mensagem central com transição tela toda */}
        <div className="relative h-4 flex items-center justify-center w-full overflow-hidden">
          <span 
            className={`text-[10px] tracking-[0.25em] font-medium transition-all duration-500 ease-in-out absolute ${
              isAnimating 
                ? slideFromLeft
                  ? 'opacity-0 translate-x-[100vw]' 
                  : 'opacity-0 -translate-x-[100vw]'
                : 'opacity-100 translate-x-0'
            }`}
          >
            {tickerMessages[currentIndex]}
          </span>
        </div>

        {/* Seta direita */}
        <button 
          onClick={handleNext}
          className="p-1.5 hover:bg-white/10 rounded transition-colors ml-6"
          aria-label="Próximo"
        >
          <ChevronRight className="h-3 w-3 text-white/50" />
        </button>
      </div>
    </div>
  );
};

export default Ticker;
